import React, { Component } from "react";
import { Button } from "@material-ui/core";
import { CollapseIcon, ExpandIcon } from "components/Icon";
import "./index.scss";

interface ExpandToggleButtonProps {
  onClick: () => void;
  expanded: boolean;
}

export default class ExpandToggleButton extends Component<
  ExpandToggleButtonProps,
  {}
> {
  render() {
    return (
      <Button
        size="small"
        onClick={this.props.onClick}
        className="expand-toggle-button"
      >
        {this.props.expanded && (
          <>
            Hide <CollapseIcon />
          </>
        )}
        {!this.props.expanded && (
          <>
            Show <ExpandIcon />
          </>
        )}
      </Button>
    );
  }
}
